import React, { useEffect, useState } from "react";
import Input from "../components/Input";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { signin, signup } from "../actions/userActions";
import Signin from "../components/Signin";
import Signup from "../components/Signup";
import sign from "../assets/sign.png";
const Login = () => {
  const [login, setLogin] = useState(true);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session);
  const [errors, setError] = useState("");
  const history = useHistory();
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
  });
  let error = {};
  const handleSubmit = async (e) => {
    e.preventDefault();
    let response = null;
    const data = {
      firstname: formData.firstname,
      lastname: formData.lastname,
      email: formData.email,
      password: formData.password,
    };
    if (!login) {
      response = await dispatch(signup(data, history));

      response &&
        response.error.forEach((data) => {
          const { param, msg } = data;
          error[`${param}`] = msg;
        });

      setError(error);
    } else {
      response = await dispatch(signin(data, history));
      response &&
        response.error.forEach((data) => {
          const { param, msg } = data;
          error[`${param}`] = msg;
        });

      setError(error);
    }
  };

  useEffect(() => {
    return () =>
      setFormData({ firstname: "", lastname: "", email: "", password: "" });
  }, []);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="widthContainer login-container">
      <div className="signin-container">
        <img src={sign} alt="" />
      </div>
      <div className="signup-container">
        {login === true && (
          <Signin
            setLogin={setLogin}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            errors={errors}
          />
        )}
        {login === false && (
          <Signup
            setLogin={setLogin}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            errors={errors}
          />
        )}
      </div>
    </div>
  );
};

export default Login;
